import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthLayout from '../common/AuthLayout';
import LoginForm from './LoginForm';

const LoginPage = ({ onNavigate }) => {
  const [searchParams] = useSearchParams();
  const emailJustVerified = searchParams.get('verified') === '1';

  const handleBackToHome = () => {
    onNavigate('main');
  };

  return (
    <AuthLayout
      title="Sign in to your account"
      subtitle="Welcome back! Please enter your details."
    >
      {emailJustVerified && (
        <div
          className="mb-4 rounded-md border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800"
          role="status"
        >
          Your email is verified. Sign in with the password you used when registering.
        </div>
      )}
      <div className="mb-4">
        <button
          onClick={handleBackToHome}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
        >
          ← Back to Home
        </button>
      </div>
      <LoginForm onNavigate={onNavigate} />
    </AuthLayout>
  );
};

export default LoginPage;
